import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Objectives from './components/Objectives';
import Programs from './components/Programs';
import CouncilTeaser from './components/CouncilTeaser';
import DonorWall from './components/DonorWall';
import Footer from './components/Footer';
import GoverningCouncil from './pages/GoverningCouncil';
import Admin from './pages/Admin';
import { LanguageProvider } from './i18n/LanguageContext';
import { useVisitTracker } from './hooks/useVisitTracker';
import { DonateProvider } from './donate/DonateContext';

const HomePage = () => (
  <div className="jbss-app">
    <Header />
    <main>
      <Hero />
      <Objectives />
      <Programs />
      <CouncilTeaser />
      <DonorWall />
    </main>
    <Footer />
  </div>
);

const VisitTracker = () => { useVisitTracker(); return null; };

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <DonateProvider>
        <VisitTracker />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/governing-council" element={<GoverningCouncil />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        </DonateProvider>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
